const { format, parseISO } = require("date-fns");

const merge = (a, b) => {
  if (a == null && b == null) return "-";
  if (a != null && b == null) return a;
  if (a == null && b != null) return b;
  if (a === b) return a;
  return `${a} / ${b}`;
};

const formatDate = (d) => (d ? format(d, "dd/MM/yyyy") : "-");

const log = (...args) => console.log(...args);

const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

const toDate = (date, defaultValue) => {
  if (!date) return defaultValue;
  else if (typeof date === "string") return parseISO(date);
  else return date;
};

module.exports = { merge, log, formatDate, capitalizeFirstLetter, toDate };
